import {
    DetailMarketFavorite,
    GlobalFavMarketOperation,
    Favorite,
    FavoriteType,
    isFavoriteEqual,
    OverviewMatchFavorite,
    OverviewTournamentFavorite
} from './Favorite';
import { LiveMatch, Prematch, Tournament } from '../dto';
import { fromJS } from 'immutable';
import moment from 'moment';
import axios from 'axios';

const EXPIRE_HOURS_MATCH = 3;
export const DATE_FORMAT_FULL = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

const toExpirationTimestamp = (startTime, hours) => {
    const startTimeDate = new Date(startTime);
    const expirationTime = new Date(startTimeDate.setHours(startTimeDate.getHours() + hours));

    return moment.utc(expirationTime).format(DATE_FORMAT_FULL);
};

export function saveFavorite(favourite: Favorite, type: string) {
    axios.post(`/api/user-settings/favourite/${type}/`, favourite).catch(() => {
        console.error('Cant save favorite ' + type);
    });
}

export function deleteFavorite(id: string, type: string, marketId?: string) {
    axios.delete(`/api/user-settings/favourite/${type}/${id}${marketId ? '/' + marketId : ''}`).catch(() => {
        console.error('Cant delete favorite ' + type);
    });
}

export function manipulateFavoriteMarketGlobally(marketId: string, operation: GlobalFavMarketOperation) {
    const url = `/api/user-settings/favourite/${FavoriteType.MarketGlobal}/${marketId}`;

    if (operation === GlobalFavMarketOperation.Save)
        axios.post(url).catch(err => {
            console.error('Can`t save favorite ' + FavoriteType.MarketGlobal, err);
        });
    else if (operation === GlobalFavMarketOperation.Delete)
        axios.delete(url).catch(err => {
            console.error('Can`t delete favorite ' + FavoriteType.MarketGlobal, err);
        });
}

export function toggleFavorite(favorite: Favorite, currentFavorites: Favorite[]): [Favorite[], boolean] {
    const existing = currentFavorites.find(existing => isFavoriteEqual(existing.toJS(), favorite.toJS()));
    if (existing) {
        return [currentFavorites.filter(fav => fav !== existing), true];
    }
    return [currentFavorites.concat([favorite]), false];
}

export function toFavoriteMatch(sportCode: string, match: LiveMatch): OverviewMatchFavorite {
    return fromJS({
        expirationTime: toExpirationTimestamp(match.startTime, EXPIRE_HOURS_MATCH),
        sportCode,
        sportId: match.sportId,
        tournamentId: match.tournamentId,
        id: match.id
    });
}
export function toFavoritePreMatch(sportCode: string, match: Prematch): OverviewMatchFavorite {
    return fromJS({
        expirationTime: toExpirationTimestamp(match.expiration, EXPIRE_HOURS_MATCH),
        sportCode,
        sportId: match.sportId,
        tournamentId: match.tournamentId,
        id: match.sportEventId
    });
}

export function toFavoriteTournament(sportCode: string, tournament: Tournament): OverviewTournamentFavorite {
    return fromJS({
        sportCode,
        sportId: tournament.sportId,
        tournamentId: tournament.id
    });
}

export function toFavoriteMarket(matchId: string, marketId: string): DetailMarketFavorite {
    return fromJS({
        matchId,
        marketId
    });
}

export function toFavoriteOverviewMarket(favorites) {
    return favorites.map((market, index) => {
        return {
            marketId: market,
            marketPosition: index
        };
    });
}

export default {
    saveFavorite
};

export function saveFavoriteOverviewMarketsApi(sportId, favourites) {
    const request = {
        sportId,
        overviewMarkets: toFavoriteOverviewMarket(favourites)
    };

    return axios.put(`/api/user-settings/favourite/tlv-overview-markets/`, request);
}

export function deleteFavoriteOverviewMarketsApi(sportId) {
    return axios.delete(`/api/user-settings/favourite/tlv-overview-markets/${sportId}`);
}
